import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { FormaPagamentoFilter } from '../../../../home/forma-pagamento/filter';
import { formaPagamentoSituacaoAtiva } from '../../../../home/forma-pagamento/forma-pagamento-situacao';
import { FormaPagamentoCrudHttpService } from '../../../../home/forma-pagamento/services';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-forma-pagamento-multiselect',
  templateUrl: './novo-forma-pagamento-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoFormaPagamentoMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoFormaPagamentoMultiselectComponent
  extends CustomControlValueAccessor<number[]> {
  @Input() idsFormasPagamentos: number[];
  @Input() somenteAtivas = true;
  @Output() idsFormasPagamentosChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione as formas de pagamento',
    plural: 'Formas de Pagamento',
    singular: 'Forma de Pagamento',
    searchEmptyResultMessage: 'Nenhuma forma de pagamento encontrada',
    showFooter: false
  };

  options: IOption[] = [];

  constructor(
    private messageService: MessageService,
    private formaPagamentoCrudHttpService: FormaPagamentoCrudHttpService
  ) {
    super();
  }

  firstOpened(isFirstOpened: boolean): void {
    if (isFirstOpened && this.options.length === 0) {
      this.create();
    }
  }

  private create() {
    const filter = new FormaPagamentoFilter();
    if (this.somenteAtivas) {
      filter.situacao = formaPagamentoSituacaoAtiva.id;
    }

    this.definirCarregando(true);

    this.formaPagamentoCrudHttpService
      .searchWithFilter(filter)
      .pipe(take(1), finalize(() => this.definirCarregando(false)))
      .subscribe(
        (formasPagamentos) => {
          if (formasPagamentos && formasPagamentos.length > 0) {
            const currentIds = this.value ?? [];
            this.options = formasPagamentos.map((entity) => ({
              id: entity.id,
              label: entity.nome,
              isChecked: currentIds.includes(entity.id)
            }));
          }
        },
        (error: ApiError) => {
          this.messageService.error(
            error.message,
            'Erro ao pesquisar as formas de pagamentos',
            error
          );
        }
      );
  }

  protected updateValue(newValue: number[] | null): void {
    const ids = newValue ?? [];
    if (ids.length > 0 && this.options.length === 0) {
      this.create();
      return;
    }
    if (this.options.length > 0) {
      this.options.forEach((o) => {
        o.isChecked = ids.includes(o.id);
      });
    }
  }

  onSearch() {
    this.idsFormasPagamentosChange.emit(this.idsFormasPagamentos);
  }

  onSelectionChange() {
    this.emitChange(this.idsFormasPagamentos);
    this.markAsTouched();
  }

  private definirCarregando(carregando: boolean): void {
    this.settings = { ...this.settings, isLoading: carregando };
  }

}
